import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import DeleteEventModal from 'components/modals/DeleteEventModal';
import MatchEndedModal from 'components/modals/MatchEndedModal';
import PauseMatchModal from 'components/modals/PauseMatchModal';
import InfoModal from 'components/modals/InfoModal';

import {
  modalsSlice,
  selectShowDeleteEventModal,
  selectShowMatchEndedModal,
  selectShowMatchNotStartedModal,
  selectShowPauseMatchModal,
  selectShowResetAndReloadModal,
  selectShowSecondHalfModal,
  selectShowStartMatchModal,
  selectInfoModal,
  selectShowFirstHalfExtraTimeModal,
  selectShowHalfTimeExtraTimeModal,
  selectShowSecondHalfExtraTimeModal,
  selectShowPenaltiesModal,
  selectConsiderReloadModal,
} from 'features/modals/modalsSlice';
import StartMatchModal from '../modals/PauseMatchModal/StartMatchModal';
import StartSecondHalfModal from '../modals/PauseMatchModal/StartSecondHalfModal';
import MatchNotStartedModal from '../modals/PauseMatchModal/MatchNotStartedModal';
import ResetAndReloadModal from '../modals/ResetAndReloadModal';
import StartFirstHalfExtraTimeModal from '../modals/PauseMatchModal/StartFirstHalfExtraTimeModal';
import HalfTimeExtraTimeModal from '../modals/PauseMatchModal/HalfTimeExtraTimeModal';
import StartSecondHalfExtraTimeModal from '../modals/PauseMatchModal/StartSecondHalfExtraTimeModal';
import PenaltiesModal from '../modals/PauseMatchModal/PenaltiesModal';
import ConsiderReloadModal from '../modals/ConsiderReloadModal';

const ModalsContainer: React.FC = () => {
  const dispatch = useDispatch();

  const showDeleteEventModal = useSelector(selectShowDeleteEventModal);
  const showMatchEndedModal = useSelector(selectShowMatchEndedModal);
  const showPauseMatchModal = useSelector(selectShowPauseMatchModal);
  const showStartMatchModal = useSelector(selectShowStartMatchModal);
  const showSecondHalfMatchModal = useSelector(selectShowSecondHalfModal);
  const showFirstHalfExtraTimeMatchModal = useSelector(selectShowFirstHalfExtraTimeModal);
  const showHalfTimeExtraTimeMatchModal = useSelector(selectShowHalfTimeExtraTimeModal);
  const showSecondHalfExtraTimeMatchModal = useSelector(selectShowSecondHalfExtraTimeModal);
  const showPenaltiesModal = useSelector(selectShowPenaltiesModal);
  const showMatchNotStartedModal = useSelector(selectShowMatchNotStartedModal);
  const showResetAndReloadModal = useSelector(selectShowResetAndReloadModal);
  const showInfoModal = useSelector(selectInfoModal);
  const showConsiderReloadModal = useSelector(selectConsiderReloadModal);

  const {
    closeDeleteEventModal,
    setMatchEndedModal,
    setPauseMatchModal,
    setStartMatchModal,
    setSecondHalfModal,
    setFirstHalfExtraTimeModal,
    setHalfTimeExtraTimeModal,
    setSecondHalfExtraTimeModal,
    setPenaltiesModal,
    setMatchNotStartedModal,
    setResetAndReloadModal,
    setInfoModal,
    setConsiderReloadModal,
  } = modalsSlice.actions;

  return (
    <div>
      <DeleteEventModal visible={showDeleteEventModal} onDismiss={() => dispatch(closeDeleteEventModal())} />
      <MatchEndedModal visible={showMatchEndedModal} onDismiss={() => dispatch(setMatchEndedModal(false))} />
      <PauseMatchModal visible={showPauseMatchModal} onDismiss={() => dispatch(setPauseMatchModal(false))} />
      <StartMatchModal visible={showStartMatchModal} onDismiss={() => dispatch(setStartMatchModal(false))} />
      <MatchNotStartedModal
        visible={showMatchNotStartedModal}
        onDismiss={() => dispatch(setMatchNotStartedModal(false))}
      />
      <StartSecondHalfModal visible={showSecondHalfMatchModal} onDismiss={() => dispatch(setSecondHalfModal(false))} />
      <StartFirstHalfExtraTimeModal
        visible={showFirstHalfExtraTimeMatchModal}
        onDismiss={() => dispatch(setFirstHalfExtraTimeModal(false))}
      />
      <HalfTimeExtraTimeModal
        visible={showHalfTimeExtraTimeMatchModal}
        onDismiss={() => dispatch(setHalfTimeExtraTimeModal(false))}
      />
      <StartSecondHalfExtraTimeModal
        visible={showSecondHalfExtraTimeMatchModal}
        onDismiss={() => dispatch(setSecondHalfExtraTimeModal(false))}
      />
      <PenaltiesModal visible={showPenaltiesModal} onDismiss={() => dispatch(setPenaltiesModal(false))} />
      <ResetAndReloadModal
        visible={showResetAndReloadModal}
        onDismiss={() => dispatch(setResetAndReloadModal(false))}
      />
      <InfoModal visible={showInfoModal} onDismiss={() => dispatch(setInfoModal(false))} />
      <ConsiderReloadModal
        visible={showConsiderReloadModal}
        onDismiss={() => dispatch(setConsiderReloadModal(false))}
      />
    </div>
  );
};

export default ModalsContainer;
